module.exports = __webpack_public_path__ + "img/LaBase-SaladeCésar-600px.3f402397.jpg";